var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3209",
    "data-name": "Rectangle 3209",
    width: 28,
    height: 28,
    transform: "translate(333 14)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5911",
    "data-name": "Mask Group 5911",
    transform: "translate(-333 -14)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7529",
    "data-name": "Group 7529",
    transform: "translate(-1448.2 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6989",
    "data-name": "Path 6989",
    d: "M267.114,23.821H280.2a2.866,2.866,0,0,1,2.851,3.161l-.465,4.493a3.821,3.821,0,0,1-3.8,3.428H271.24a3.821,3.821,0,0,1-3.79-3.335l-1.055-8.232A3.821,3.821,0,0,0,262.6,20H261",
    transform: "translate(1523.2 7)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 1.659,
    cy: 1.659,
    r: 1.659,
    transform: "translate(1792.33 45.604)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 1.659,
    cy: 1.659,
    r: 1.659,
    transform: "translate(1800.626 45.604)",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartLogo);
export default __webpack_public_path__ + "static/media/Cart_logo.b5fb4278fc4fbbee9db133aa943bef8f.svg";
export { ForwardRef as ReactComponent };